/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import { ACTIVITY_HISTORY_DEVICE_TYPE, ACTIVITY_HISTORY_TYPE } from '@hems/util/src/constant/activityHistory';

import type { ActivityHistoryResponse } from 'hems/activityHistory';

export const activityHistoryData: ActivityHistoryResponse = {
  context: {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 3,
  },
  data: [
    {
      siteId: 100001234,
      activityType: ACTIVITY_HISTORY_TYPE.INSTALL,
      deviceType: ACTIVITY_HISTORY_DEVICE_TYPE.AC_COMBINER,
      deviceId: '34261111542AI29101',
      previousDeviceId: '34261111542AI29100',
      eventDate: '2025-04-30T13:00:00-08:00',
      updateUser: 'admin@qcells.com',
      eventDateUtc: '2025-04-30T21:00:00Z',
      activityTypeText: 'code.acttypecd.30',
      deviceTypeText: 'AC Combiner',
      subDeviceId: null,
      previousSubDeviceId: null,
    },
    {
      siteId: 100001234,
      activityType: ACTIVITY_HISTORY_TYPE.REPLACE,
      deviceType: ACTIVITY_HISTORY_DEVICE_TYPE.AC_COMBINER,
      deviceId: '34261111542AI29101',
      previousDeviceId: '34261111542AI29100',
      eventDate: '2025-05-01T14:00:00-08:00',
      updateUser: 'admin@qcells.com',
      eventDateUtc: '2025-05-01T22:00:00Z',
      activityTypeText: 'code.acttypecd.60',
      deviceTypeText: 'AC Combiner',
      subDeviceId: null,
      previousSubDeviceId: null,
    },
    {
      siteId: 100001234,
      activityType: ACTIVITY_HISTORY_TYPE.DELETE,
      deviceType: ACTIVITY_HISTORY_DEVICE_TYPE.AC_COMBINER,
      deviceId: '34261111542AI29101',
      previousDeviceId: '34261111542AI29100',
      eventDate: '2025-05-02T13:00:00-08:00',
      updateUser: 'admin@qcells.com',
      eventDateUtc: '2025-05-02T21:00:00Z',
      activityTypeText: 'code.acttypecd.90',
      deviceTypeText: 'AC Combiner',
      subDeviceId: null,
      previousSubDeviceId: null,
    },
  ],
};
